import { useParams, useSearch } from "@tanstack/react-router";

/**
 * Resolves the current request id from the URL without depending on the request
 * detail query. Mirrors the id resolution used by `useGetRequest` (route param
 * first, then the `request_id`/`draft_id` search params) so that the request
 * detail, attachments and chat stream can all start loading in parallel instead
 * of waterfalling behind the request detail response.
 */
export function useRequestId() {
  const params = useParams({ shouldThrow: false, strict: false });
  const { ["draft_id"]: draftId, ["request_id"]: requestIdFromSearch } =
    useSearch({ strict: false });

  return params?.requestId ?? requestIdFromSearch ?? draftId;
}
